module.exports = __webpack_public_path__ + "src/assets/img/cmd-go-alarm-stop.bdacddb2.svg";